import messages, { MSG_TITLE, MSG_TYPE } from './messages';
import store from '@/store';
import _ from 'lodash';
import Router from '@/router';
import repository, { isAbort } from '@/utils/repository';
import kuromoji from 'kuromoji';
const customKanjiDict = {
    桒: 'クワ'
};
import axios from 'axios';
export default {
    createNotification(message) {
        const notification = new Notification(message.title, {
            body: message.body
        });
        notification.onclick = function (event) {
            event.preventDefault();
            window.open(window.location.origin + message.screen_refer, '_blank');
        };
    },
    notificationApi(message) {
        if (!window.Notification) {
            console.log('Browser does not support notifications.');
        } else {
            // check if permission is already granted
            if (Notification.permission === 'granted') {
                this.createNotification(message);
            } else {
                // request permission from user
                Notification.requestPermission()
                    .then(function (p) {
                        if (p === 'granted') {
                            this.createNotification(message);
                        } else {
                            console.log('User blocked notifications.');
                        }
                    })
                    .catch(function (err) {
                        console.error(err);
                    });
            }
        }
    },
    checkNotIMECharacter(str) {
        const fullSizeNumber = ['０', '１', '２', '３', '４', '５', '６', '７', '８', '９', '（', '）', 'ー', ' ', '。'];
        for (let i = 0; i <= fullSizeNumber.length; i++) {
            if (str.includes(fullSizeNumber[i])) {
                return false;
            }
        }
        const n = Math.floor(Number(str));
        return n !== Infinity && n >= 0;
    },
    removeJapaneseCharacter: (str) => {
        if (str == undefined || str == null) {
            return '';
        }
        const regex = /[\u3000-\u303F]|[\u3040-\u309F]|[\u30A0-\u30FF]|[\uFF00-\uFFEF]|[\u4E00-\u9FAF]|[\u2605-\u2606]|[\u2190-\u2195]|\u203B/g;
        return str.replace(regex, '');
    },
    isValidData: (data, rules, focus = true, messageCode = 'E001', customMsg = false) => {
        try {
            const isEmail = (str) => {
                if (str == null || str == undefined || str == '') {
                    return true;
                }
                return String(str)
                    .toLowerCase()
                    .match(
                        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    );
            };
            let isValid = true;
            // const screenId = store.state.app.screenId;
            for (const key in rules) {
                if (Object.prototype.hasOwnProperty.call(rules, key)) {
                    let tbl = '';
                    let itemID = '';
                    const value = rules[key];
                    const values = value.split('|');
                    const length = values.length;
                    if (tbl == undefined || tbl == null || tbl == '') {
                        tbl = '項目';
                    }
                    for (let i = 0; i < length; i++) {
                        const rule = values[i];
                        const checks = rule.split(':');
                        if (checks[0] == 'required') {
                            if (focus) {
                                // remove class require-input online and focus
                                if (itemID && !customMsg) {
                                    document.getElementsByName(itemID)[0]?.classList.remove('require-input');
                                } else {
                                    document.getElementsByName(tbl)[0]?.classList.remove('require-input');
                                }
                            }
                            if (!Object.prototype.hasOwnProperty.call(data, key) || data[key] == null || data[key] == '') {
                                if (isValid) {
                                    if (customMsg) {
                                        // const itemID = item[screenId][key];
                                        store.commit('app/showHeaderError', [messages[itemID]]);
                                    } else {
                                        store.commit('app/showHeaderError', [tbl + messages[messageCode]]);
                                    }
                                    // add class require-input online and focus
                                    if (itemID && !customMsg) {
                                        document.getElementsByName(itemID)[0]?.classList.add('require-input');
                                        document.getElementsByName(itemID)[0].focus();
                                    } else {
                                        document.getElementsByName(tbl)[0]?.classList.add('require-input');
                                        document.getElementsByName(tbl)[0].focus();
                                    }
                                }
                                isValid = false;
                            } else {
                                if (focus) {
                                    // remove class require-input online and focus
                                    if (itemID && !customMsg) {
                                        document.getElementsByName(itemID)[0]?.classList.remove('require-input');
                                    } else {
                                        document.getElementsByName(tbl)[0]?.classList.remove('require-input');
                                    }
                                }
                            }
                        }
                        if (checks[0] == 'email') {
                            if (!isEmail(data[key])) {
                                if (isValid) {
                                    store.commit('app/showHeaderError', [messages.E134]);
                                }
                                isValid = false;
                            }
                        }
                    }
                }
            }
            return isValid;
        } catch (e) {
            console.log('validData: ' + e.message);
            return false;
        }
    },
    isNullOrEmpty: (str) => {
        if (str == undefined || str == null || str == '' || str.trim() == '') {
            return true;
        }
        return false;
    },
    encodeParams: (params) => {
        try {
            if (params == undefined || params == null || params.length == 0) {
                return '';
            }
            let output = btoa(encodeURIComponent(JSON.stringify(params)));
            let endPos = 0;
            for (endPos = output.length; endPos > 0; endPos--) {
                if (output[endPos - 1] !== '=') {
                    break;
                }
            }
            const numberPaddingChars = output.length - endPos;
            output = output.replace(/\+/g, '-');
            output = output.replace(/\//g, '_');
            output = output.substring(0, endPos);
            output = output + numberPaddingChars;

            return output;
        } catch (e) {
            console.log(e);
            return '';
        }
    },
    func_back: (isDelete = false) => {
        let historyURL = JSON.parse(sessionStorage.getItem('historyURL'));
        if (!historyURL) {
            historyURL = [];
        }
        let lastObj = _.last(historyURL);

        if (lastObj && lastObj.backupData) {
            let backup = lastObj.name.toLowerCase() + '_backup';
            if (lastObj && lastObj['backupData']) {
                sessionStorage.setItem(backup, lastObj.backupData);
            }
        }

        if (isDelete) {
            const length = historyURL.length;
            if (length >= 2) {
                if (lastObj.path.split('').pop() == 'l') {
                    historyURL = _.dropRight(historyURL);
                } else {
                    historyURL.forEach((element) => {
                        if (element.path == lastObj.path) {
                            historyURL = _.dropRight(historyURL);
                        }
                    });
                    lastObj = _.last(historyURL);
                    if (lastObj.path.split('').pop() == 'l') historyURL = _.dropRight(historyURL);
                }
            }
        } else {
            historyURL = _.dropRight(historyURL);
        }
        sessionStorage.setItem('historyURL', JSON.stringify(historyURL));
        store.commit('app/setBacking', true);
        // if (lastObj && lastObj.p.p)
        //     Router.push({
        //         name: lastObj.name,
        //         query: {
        //             p: lastObj.p.p
        //         }
        //     });
        // if (lastObj) Router.push({ name: lastObj.name });
        // else Router.push({ path: '/' });
        if (!lastObj) {
            Router.push({ path: '/' });
        } else {
            if (lastObj.p.p) {
                Router.push({
                    name: lastObj.name,
                    query: {
                        p: lastObj.p.p
                    }
                });
            } else {
                Router.push({
                    name: lastObj.name
                });
            }
        }
    },
    // type: 1 - add; 0 - remove
    handleAddRemoveClass(data = []) {
        data.forEach((value) => {
            let { ele = null, arrAddRemove = [], type = 1 } = value;
            type ? ele?.classList?.add(...arrAddRemove) || null : ele?.classList?.remove(...arrAddRemove) || null;
        });
    },
    removeAllRequireInput() {
        const groupClass = document.getElementsByClassName('require-input');
        const length = groupClass.length ?? 0;

        for (let i = 0; i < length; i++) {
            groupClass[i]?.classList.remove('require-input');
        }
    },
    handleResize() {
        const divTblTop = document.getElementById('header-stick');
        const divTblScroll = document.getElementById('table-scroll');
        const divGroup1 = document.getElementById('group-1');

        if (!divTblScroll) return;

        let maxHeight = window.innerHeight - (divTblTop.offsetHeight + (divGroup1 ? divGroup1.offsetHeight : 0) + 23);

        divTblScroll.style.maxHeight = `${maxHeight}px`;
    },
    clearAllRequireInput: () => {
        const elm = document.getElementsByClassName('require-input');
        for (let i of elm) {
            setTimeout(() => {
                i.classList.remove('require-input');
            }, 50);
        }
    },
    formatMoney(number) {
        const isNegative = number < 0;
        const absoluteAmount = Math.abs(number);
        const formattedAmount = `￥${absoluteAmount.toLocaleString()}`;

        return isNegative ? `￥-${formattedAmount.substring(1)}` : formattedAmount;
    },
    dropDown(refList = [], defautSetting = {}) {
        if (!Array.isArray(refList)) {
            refList = [refList];
        }

        const df = {
            padding: 10,
            top: 0,
            height: 'unset',
            display: 'none',
            left: 'auto',
            right: 'auto',
            checkHasListChild: false,
            classNameList: 'autoDropdown',
            ...defautSetting
        };

        for (let i = 0; i < refList.length; i++) {
            const wrap = refList[i];
            const list = wrap.querySelector('.dropdown-menu');

            wrap.addEventListener('mouseenter', (e) => {
                ///////////////////////////////////////////////////////////////////////////
                // init
                list.style.position = 'fixed';
                list.style.display = 'block';

                const rectWrap = e.target.getBoundingClientRect();
                const { top: topParentDiv, right: rightParentDiv } = rectWrap;

                list.style.position = 'absolute';

                ///////////////////////////////////////////////////////////////////////////
                // window/document info
                const heightViewport = window.innerHeight;
                const widthViewport = window.innerWidth;
                const heightScrollX = document.documentElement.offsetHeight - document.documentElement.clientHeight;

                ///////////////////////////////////////////////////////////////////////////
                // list info
                const heightUl = list.offsetHeight;
                const widthUl = list.offsetWidth;

                ///////////////////////////////////////////////////////////////////////////
                // TOP: check space contains list
                if (topParentDiv + heightUl > heightViewport) {
                    const dimension = topParentDiv + heightUl - heightViewport;

                    const heightViewportNotScrollBottomHeight = heightViewport - heightScrollX;

                    // check space available
                    if (heightUl <= heightViewportNotScrollBottomHeight) {
                        list.style.overflowY = 'unset';

                        // padding-bottom: 10px; (example)
                        if (heightUl + df.padding <= heightViewportNotScrollBottomHeight) {
                            list.style.top = -dimension - df.padding - heightScrollX + 'px';
                        } else {
                            list.style.top = -dimension - heightScrollX + 'px';
                        }
                    } else {
                        // padding-top = padding-bottom = 10px; (example)
                        list.style.top = -topParentDiv + df.padding + 'px';

                        if (
                            !df.checkHasListChild ||
                            // check has 'dropdown child' => not set scrollY
                            (df.checkHasListChild &&
                                // if not exitst 'dropdown child'
                                !list.getElementsByClassName(df.classNameList)[0])
                        ) {
                            list.style.overflowY = 'auto';
                            list.style.overflowX = 'hidden';
                            list.style.height = heightViewportNotScrollBottomHeight - df.padding * 2 + 'px';
                        }
                    }
                } else {
                    if (topParentDiv + heightUl > heightViewport - heightScrollX) {
                        list.style.top = df.top - heightScrollX + 'px';
                    } else {
                        list.style.top = df.top + 'px';
                    }
                }

                ///////////////////////////////////////////////////////////////////////////
                // LEFT: check space contains list (default show in right side)
                if (rightParentDiv + widthUl > widthViewport) {
                    list.style.right = '100%';
                } else {
                    list.style.left = '100%';
                }
            });

            wrap.addEventListener('mouseleave', () => {
                // TOP: reset
                list.style.display = df.display;
                list.style.removeProperty('overflow-y');
                list.style.height = df.height;
                list.style.top = df.top;

                // LEFT: reset
                list.style.removeProperty('overflow-x');
                list.style.left = df.left;
                list.style.right = df.right;
            });
        }
    },
    isValidPassword(value) {
        const isNonWhiteSpace = /^\S*$/;
        if (!isNonWhiteSpace.test(value)) {
            return false;
        }
        const isValidLength = /^.{10,30}$/;
        if (!isValidLength.test(value)) {
            return false;
        }
        let countPattern = 0;
        const isContainsUppercase = /^(?=.*[A-Z]).*$/;
        if (isContainsUppercase.test(value)) {
            countPattern += 1;
        }
        const isContainsLowercase = /^(?=.*[a-z]).*$/;
        if (isContainsLowercase.test(value)) {
            countPattern += 1;
        }
        const isContainsNumber = /^(?=.*[0-9]).*$/;
        if (isContainsNumber.test(value)) {
            countPattern += 1;
        }
        const isContainsSymbol = /^(?=.*[~`!@#$%^&*()--+={}[\]|\\:;"'<>,.?/_₹]).*$/;
        if (isContainsSymbol.test(value)) {
            countPattern += 1;
        }
        if (countPattern < 3) {
            return false;
        }
        const isAlphaAndSymbols = /^[a-zA-Z\s~`!@#$%^&*()-_=+[\]{}|;:'",.<>?]*$/;
        if (!isAlphaAndSymbols.test(value)) {
            return false;
        }
        return true;
    },
    renderError(errors, S9007) {
        return Object.keys(errors).map((key) => {
            return {
                name: key.toLowerCase(),
                message: _.isArray(errors[key]) ? S9007[errors[key][0]] : S9007[errors[key]]
            };
        });
    },
    checkIfMobile() {
        return window.innerWidth <= 767;
        // return window.screen.width <= 835;
    },
    checkScreenId() {
        return store.state.app.screenId;
    },
    focusInput(list) {
        setTimeout(() => {
            document.getElementById('input-' + (list.length - 1))?.focus();
        }, 100);
    },
    createTokenizer: async () => {
        return new Promise((resolve, reject) => {
            const tokenizerBuilder = kuromoji.builder({
                dicPath: '/kuromoji-dict'
            });

            tokenizerBuilder.build((err, tokenizer) => {
                if (err) reject(err);
                else resolve(tokenizer);
            });
        });
    },
    convertToFurigana: async (text, tokenizer) => {
        if (!tokenizer) {
            throw new Error('Tokenizer is not initialized');
        }
        const tokens = tokenizer.tokenize(text);
        const furigana = tokens
            .map((token) => {
                if (token.reading) {
                    return token.reading;
                }
                const furiganaFromWanakana = customKanjiDict[token.surface_form];
                return furiganaFromWanakana || token.surface_form;
            })
            .join('');
        return furigana;
    },
    sortNull(arr, ascending, key, number = false, date = false) {
        if (typeof ascending === 'undefined') ascending = true;

        const multiplier = ascending ? 1 : -1;
        const sorter = function (a, b) {
            let str = 0;
            if (a[key] === b[key]) return 0;
            else if (a[key] === null || a[key] == '') {
                str = 1;
            } else if (b[key] === null || b[key] == '') {
                str = -1;
            } else {
                if (number) {
                    str = (a.read || a[key]) < (b.read || b[key]) ? -1 : 1;
                } else if (date) {
                    str = new Date(a.date) < new Date(b.date) ? -1 : 1;
                } else {
                    str = a?.[key]?.localeCompare(b?.[key], 'ja', {
                        numeric: true,
                        sensitivity: 'base'
                    });
                }
            }
            return str * multiplier;
        };

        return arr.sort(sorter);
    },
    checkAuthorityMode(routeName) {
        const noAuthenticate = [
            'CUS_Register001',
            'CUS_Register002',
            'CUS_Register003',
            'CUS_Register004',
            'CUS_Register005',
            'CUS_Start001',
            'CUS_Start002',
            'CUS_Start003',
            'CUS_Start004',
            'CUS_Start005',
            'CUS_Start011',
            'CUS_Start021',
            'CUS_Start022',
            'CUS_Start023',
            'CUS_Start024',
            'CUS_Start025',
            'CUS_Start026',
            'FAQContact',
            'CUS_System903',
            'MNG_System903'
        ];
        if (noAuthenticate.includes(routeName) || routeName.includes('APP') || routeName.includes('PTJ')) {
            return;
        }
        const authority = localStorage.getItem('authority');
        const mode = routeName.includes('CUS') ? 1 : 2;
        return authority != mode;
    },
    // getFileToDownload: (params) => {
    //     return repository
    //         .post('/move/checkFileExist', params)
    //         .then((response) => {
    //             if (response['data']['Code'] == 200) {
    //                 var urlDownloadFile = `${process.env.VUE_APP_BASE_DOMAIN}/getFileToDownload`;
    //                 urlDownloadFile +=
    //                     '?' +
    //                     Object.keys(params)
    //                         .map((key) => {
    //                             return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
    //                         })
    //                         .join('&');
    //                 window.location.href = urlDownloadFile;
    //                 return;
    //             }
    //         })
    //         .catch(console.error);
    // },
    getFileToDownload: (params) => {
        return repository
            .post('/move/checkFileExist', params)
            .then((response) => {
                if (response['data']['Code'] == 200) {
                    let fileName = response['data']['Data']['fileName'] ?? '';
                    let newFileName = response['data']['Data']['newFileName'] ?? '';
                    let paramFiles = {};
                    paramFiles['fileName'] = fileName;
                    paramFiles['newFileName'] = newFileName;
                    var urlDownloadFile = `${process.env.VUE_APP_BASE_DOMAIN}/getFileToDownload`;
                    urlDownloadFile +=
                        '?' +
                        Object.keys(paramFiles)
                            .map((key) => {
                                return encodeURIComponent(key) + '=' + encodeURIComponent(paramFiles[key]);
                            })
                            .join('&');
                    window.location.href = urlDownloadFile;
                    return;
                }
            })
            .catch(console.error);
    },
    getFileToDownloadSys004: (params) => {
        return repository
            .post('/move/checkFileExistSys004', params)
            .then((response) => {
                if (response['data']['Code'] == 200) {
                    let fileName = response['data']['Data']['fileName'] ?? '';
                    let newFileName = response['data']['Data']['newFileName'] ?? '';
                    let paramFiles = {};
                    paramFiles['fileName'] = fileName;
                    paramFiles['newFileName'] = newFileName;
                    var urlDownloadFile = `${process.env.VUE_APP_BASE_DOMAIN}/getFileToDownload`;
                    urlDownloadFile +=
                        '?' +
                        Object.keys(paramFiles)
                            .map((key) => {
                                return encodeURIComponent(key) + '=' + encodeURIComponent(paramFiles[key]);
                            })
                            .join('&');
                    window.location.href = urlDownloadFile;
                    return;
                }
            })
            .catch(console.error);
    },
    downloadFromPublic: (params) => {
        const paramFiles = {};
        paramFiles['newFileName'] = params.newFileName;
        paramFiles['fileName'] = params.fileName;
        let urlDownloadFile = `${process.env.VUE_APP_BASE_DOMAIN}/getFileToDownload`;
        urlDownloadFile +=
            '?' +
            Object.keys(paramFiles)
                .map((key) => {
                    return encodeURIComponent(key) + '=' + encodeURIComponent(paramFiles[key]);
                })
                .join('&');
        window.location.href = urlDownloadFile;
    },
    getDueDateCommon: (closing_date, closing_date_payment, date_of_payment) => {
        let params = {
            closing_date: closing_date,
            closing_date_payment: closing_date_payment,
            date_of_payment: date_of_payment
        };
        return repository
            .post('/move/getDueDate', params)
            .then((response) => {
                let count_date = response.data.Data['count_date'];
                return count_date;
            })
            .catch(console.error);
    },
    openFilePdf: (params) => {
        console.log(params);
        params.showFile = 1;
        return repository
            .post('/move/checkFileExist', params, {
                responseType: 'blob'
            })
            .then((response) => {
                if (response.headers['content-type'] != 'application/json') {
                    const file = new Blob([response.data], {
                        type: 'application/pdf'
                    });
                    const objectUrl = window.URL.createObjectURL(file);
                    window.open(objectUrl);
                }
            })
            .catch(console.error);
    },
    checkExistFile: (body) => {
        return repository
            .post('/move/checkFileExist', body.params)
            .then((response) => {
                if (response['data']['Code'] == 200) {
                    if (body.callback) {
                        body.callback(response['data']['Data']);
                    }
                }
            })
            .catch(console.error);
    },
    checkOverMaxFileSize(dataFile) {
        const isOver = dataFile.size > parseInt(process.env.VUE_APP_FILE_UPLOAD_SIZE) * 1048576;
        if (isOver) {
            store.commit('app/showModalMessage', {
                type: MSG_TYPE.ERROR,
                title: MSG_TITLE.S001,
                content: '添付資料のファイルサイズが大きすぎます！(合計' + process.env.VUE_APP_FILE_UPLOAD_SIZE + 'MBまで)',
                okText: 'OK'
            });
        }
        return isOver;
    },
    getDisplayCompanyName() {
        return repository
            .get('/move/getDisplayCompanyName')
            .then((response) => {
                let companyName = response.data.Data;
                return companyName;
            })
            .catch(console.error);
    },
    getDataSys005(params, axiosConfig = {}) {
        const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
        const companyCd = params?.company_cd ?? userInfo?.company_cd ?? '';
        const payload = { ...params };
        if (companyCd !== '' && companyCd !== null && companyCd !== undefined) {
            payload.company_cd = companyCd;
        }
        return repository
            .post('/move/getDataSys005', payload, axiosConfig)
            .then((response) => {
                if (response.data.Code === 200) {
                    return response.data.Data ?? [];
                }
                return [];
            })
            .catch((error) => {
                if (isAbort(error)) {
                    throw error;
                }
                console.error(error);
                return [];
            });
    },
    getTaxRate(axiosConfig = {}) {
        return repository
            .get('/move/getTaxRate', axiosConfig)
            .then((response) => {
                if (response.data.Code === 200) {
                    return response.data.Data?.tax_rate ?? 0;
                }
                return 0;
            })
            .catch((error) => {
                if (isAbort(error)) {
                    throw error;
                }
                console.error(error);
                return 0;
            });
    },
    // 2024/12/12
    convertBelongingsInsert(data = []) {
        let belongings_kubun = ['0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0'];
        data.forEach((value) => {
            belongings_kubun[value - 1] = '1';
        });
        return belongings_kubun.join('');
    },
    convertBelongingsGet(data) {
        let belongings_kubun = [];
        let dataLast = data ? data.split('') : [];
        dataLast.forEach((value, index) => {
            if (value == '1') {
                belongings_kubun.push(String(index + 1));
            }
        });
        return belongings_kubun;
    },
    getMobileOperatingSystem() {
        var userAgent = navigator.userAgent || navigator.vendor || window.opera;

        // Windows Phone must come first because its UA also contains "Android"
        if (/windows phone/i.test(userAgent)) {
            return 'Windows Phone';
        }

        if (/android/i.test(userAgent)) {
            return 'Android';
        }

        // iOS detection from: http://stackoverflow.com/a/9039885/177710
        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            return 'iOS';
        }

        return 'unknown';
    },
    getUseBrowsers() {
        if ((navigator.userAgent.indexOf('Opera') || navigator.userAgent.indexOf('OPR')) != -1) {
            return 'Opera';
        } else if (navigator.userAgent.indexOf('Edg') != -1) {
            return 'Edge';
        } else if (navigator.userAgent.indexOf('Chrome') != -1) {
            return 'Chrome';
        } else if (navigator.userAgent.indexOf('Safari') != -1) {
            return 'Safari';
        } else if (navigator.userAgent.indexOf('Firefox') != -1) {
            return 'Firefox';
        } else if (navigator.userAgent.indexOf('MSIE') != -1 || !!document.documentMode == true) {
            //IF IE > 10
            return 'IE';
        } else {
            return 'unknown';
        }
    },
    renderMsgErr(errors) {
        var list_err = errors.map((error) => error.message);
        const uniqueArrErr = list_err.reduce((uniqueArr, item) => {
            return uniqueArr.includes(item) ? uniqueArr : [...uniqueArr, item];
        }, []);
        return uniqueArrErr.join('\n');
    },
    convertToHalfWidth(chars) {
        return chars.replace(/[！-～]/g, (halfwidthChar) => String.fromCharCode(halfwidthChar.charCodeAt(0) - 0xfee0));
    },
    convertKanaToFullWidth(string) {
        let characters = string.split('');
        let halfWidthString = '';
        characters.forEach((character) => {
            halfWidthString += this.mapToKana(character);
        });
        return halfWidthString;
    },
    mapToKana(character) {
        let convertMap = this.getConvertKanaFullSize();
        if (typeof convertMap[character] === 'undefined') {
            return character;
        } else {
            return convertMap[character];
        }
    },
    getConvertKanaFullSize() {
        let convertMap = {
            ｧ: 'ァ',
            ｱ: 'ア',
            ｨ: 'ィ',
            ｲ: 'イ',
            ｩ: 'ゥ',
            ｳ: 'ウ',
            ｪ: 'ェ',
            ｴ: 'エ',
            ｫ: 'ォ',
            ｵ: 'オ',
            ｶ: 'カ',
            ｶﾞ: 'ガ',
            ｷ: 'キ',
            ｷﾞ: 'ギ',
            ｸ: 'ク',
            ｸﾞ: 'グ',
            ｹ: 'ケ',
            ｹﾞ: 'ゲ',
            ｺ: 'コ',
            ｺﾞ: 'ゴ',
            ｻ: 'サ',
            ｻﾞ: 'ザ',
            ｼ: 'シ',
            ｼﾞ: 'ジ',
            ｽ: 'ス',
            ｽﾞ: 'ズ',
            ｾ: 'セ',
            ｾﾞ: 'ゼ',
            ｿ: 'ソ',
            ｿﾞ: 'ゾ',
            ﾀ: 'タ',
            ﾀﾞ: 'ダ',
            ﾁ: 'チ',
            ﾁﾞ: 'ヂ',
            ｯ: 'ッ',
            ﾂ: 'ツ',
            ﾂﾞ: 'ヅ',
            ﾃ: 'テ',
            ﾃﾞ: 'デ',
            ﾄ: 'ト',
            ﾄﾞ: 'ド',
            ﾅ: 'ナ',
            ﾆ: 'ニ',
            ﾇ: 'ヌ',
            ﾈ: 'ネ',
            ﾉ: 'ノ',
            ﾊ: 'ハ',
            ﾊﾞ: 'バ',
            ﾊﾟ: 'パ',
            ﾋ: 'ヒ',
            ﾋﾞ: 'ビ',
            ﾋﾟ: 'ピ',
            ﾌ: 'フ',
            ﾌﾞ: 'ブ',
            ﾌﾟ: 'プ',
            ﾍ: 'ヘ',
            ﾍﾞ: 'ベ',
            ﾍﾟ: 'ペ',
            ﾎ: 'ホ',
            ﾎﾞ: 'ボ',
            ﾎﾟ: 'ポ',
            ﾏ: 'マ',
            ﾐ: 'ミ',
            ﾑ: 'ム',
            ﾒ: 'メ',
            ﾓ: 'モ',
            ｬ: 'ャ',
            ﾔ: 'ヤ',
            ｭ: 'ュ',
            ﾕ: 'ユ',
            ｮ: 'ョ',
            ﾖ: 'ヨ',
            ﾗ: 'ラ',
            ﾘ: 'リ',
            ﾙ: 'ル',
            ﾚ: 'レ',
            ﾛ: 'ロ',
            '': 'ヮ',
            ﾜ: 'ワ',
            ｦ: 'ヲ',
            ﾝ: 'ン',
            ｳﾞ: 'ヴ',
            '･': '・',
            ｰ: 'ー'
        };
        return convertMap;
    },
    isValidJSON(str) {
        try {
            const parsed = JSON.parse(str);
            return parsed !== null && typeof parsed === 'object' && !Array.isArray(parsed);
        } catch (e) {
            return false;
        }
    },
    clearLocalStorageExcept(keysToKeep) {
        const itemsToKeep = {};
        keysToKeep.forEach((key) => {
            itemsToKeep[key] = localStorage.getItem(key);
        });

        localStorage.clear();

        Object.keys(itemsToKeep).forEach((key) => {
            if (itemsToKeep[key] !== null) {
                localStorage.setItem(key, itemsToKeep[key]);
            }
        });
    },
    convertTime(string) {
        if (string == '') {
            return '';
        }
        const hour = Math.floor(string / 100);
        const minute = string % 100;
        return `${hour}:${minute.toString().padStart(2, '0')}`;
    },
    parseTimeToMinutes(time) {
        const hours = Math.floor(time / 100);
        const minutes = time % 100;
        return hours * 60 + minutes;
    },
    validateItemTime(start_time, end_time, input_id, first_date, last_date) {
        const now = new Date();
        const nextYearDate = new Date(now);
        nextYearDate.setFullYear(now.getFullYear() + 1);

        const firstDaySelected = first_date;
        const lastDaySelected = last_date;

        const convertStartTime = this.convertTime(start_time);
        const convertEndTime = this.convertTime(end_time);

        const startDateTime = lastDaySelected == undefined || convertStartTime == '' ? null : new Date(`${lastDaySelected} ${convertStartTime}`);
        const endDateTime = convertEndTime == '' ? null : new Date(`${firstDaySelected} ${convertEndTime}`);

        const startTime = start_time.replace(':', '');
        const endTime = end_time.replace(':', '');
        const endTimeRounded = endTime == '2359' || endTime == '0000' ? '2400' : endTime;
        const startMinutes = this.parseTimeToMinutes(startTime);
        const endMinutes = this.parseTimeToMinutes(endTime);
        const endMinutesRounded = this.parseTimeToMinutes(endTimeRounded);
        const isFillAll = startTime == '' || endTime == '' ? false : true;
        // case 1
        if (startMinutes % 5 !== 0) {
            return [true, 1];
        }
        if (endMinutesRounded % 5 !== 0) {
            return [true, 1];
        }
        // case 2
        if (isFillAll) {
            if (endMinutesRounded > startMinutes && endMinutesRounded - startMinutes < 180) {
                return [true, 2];
            }
            if (endMinutesRounded < startMinutes && Math.abs(endMinutesRounded - startMinutes) > 1260) {
                return [true, 2];
            }
        }
        // case 3
        if ((endMinutesRounded - startMinutes) % 30 !== 0 && isFillAll) {
            return [true, 3];
        }
        // check time
        if (startDateTime > nextYearDate) {
            return [true, 4];
        }
        if (endDateTime == null && input_id == 'end_time') {
            return [true, 6];
        }
        if (endDateTime != null && input_id == 'end_time') {
            if (endDateTime < now && endMinutes < startMinutes) {
                return [true, 5];
            }
        }

        // not error
        return [false, 0];
    },
    adjustDate(days, targetDate = '') {
        let currentDate;

        // If target date is empty, use current date
        if (!targetDate) {
            currentDate = new Date();
        } else {
            // Parse the date string (format: YYYY/MM/DD)
            const dateParts = targetDate.split('/');
            currentDate = dateParts.length === 3 ? new Date(dateParts[0], dateParts[1] - 1, dateParts[2]) : new Date();
        }

        // Adjust the date by specified days
        currentDate.setDate(currentDate.getDate() + days);

        // Format back to YYYY/MM/DD
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');

        return `${year}/${month}/${day}`;
    },
    renderPath(imageName) {
        return process.env.VUE_APP_BASE_DOMAIN + '/' + imageName;
    },
    version() {
        return process.env.VUE_APP_VERSION ?? '2.0';
    },
    getCurrentTime() {
        //not screen loading
        const baseUrl = process.env.VUE_APP_BASE_DOMAIN + process.env.VUE_APP_BASE_PATH;
        return axios
            .get(baseUrl + '/move/getCurrentTime')
            .then((response) => {
                let currentTime = response.data.datetime;
                return currentTime;
            })
            .catch((err) => {
                console.error('Lỗi API:', err);
            });
    }
    /*
        return repository
            .get('/move/getCurrentTime')
            .then((response) => {
                let currentTime = response.data.datetime;
                console.log('ssss ' + currentTime);
                return currentTime;
            })
            .catch(console.error);
    }
    */
};
